import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { DeviceService } from '@services/device.service';
import { SetDeviceSuccess, Type } from './context.actions';

@Injectable()
export class ContextEffects {
  constructor(private actions$: Actions, readonly deviceService: DeviceService) {}

  public Navigation$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(Type.SET_DEVICE_INIT),
      switchMap(() => {
        return this.deviceService.setDevice().pipe(
          map((payload: any) => {
            return new SetDeviceSuccess(payload);
          }),
        );
      }),
    ),
  );
}
